export default __webpack_public_path__ + "static/media/WINGS-USDC-BUSD.cdb585fa.svg";